import { api } from "./api";

/** Inbox API helpers, admin-only. */
export const inboxApi = {
  list: (params = {}) => api.get("/inbox/list", { params }).then((r) => r.data),
  counts: () => api.get("/inbox/counts").then((r) => r.data),
  detail: (id) => api.get(`/inbox/${id}`).then((r) => r.data),
  assume: (id) => api.post(`/inbox/${id}/assume`).then((r) => r.data),
  resolve: (id) => api.post(`/inbox/${id}/resolve`).then((r) => r.data),
  escalate: (id) => api.post(`/inbox/${id}/escalate`).then((r) => r.data),
  note: (id, note) => api.post(`/inbox/${id}/note`, { note }).then((r) => r.data),
};

const TYPE_LABEL = {
  DUVIDA: "Dúvida", ORACAO: "Oração", CRISE: "Crise", GERAL: "Geral",
};
const TYPE_TONE = {
  DUVIDA: "bg-blue-500/15 text-blue-700 border-blue-500/30",
  ORACAO: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30",
  CRISE: "bg-rose-500/15 text-rose-700 border-rose-500/40",
  GERAL: "bg-slate-500/15 text-slate-700 border-slate-500/30",
};
const STATUS_LABEL = {
  novo: "Novo", andamento: "Em andamento",
  respondido: "Respondido", escalado: "Escalado",
};
const STATUS_TONE = {
  novo: "bg-amber-100 text-amber-800",
  andamento: "bg-sky-100 text-sky-800",
  respondido: "bg-emerald-100 text-emerald-800",
  escalado: "bg-rose-100 text-rose-800",
};

export const inboxLabels = { TYPE_LABEL, TYPE_TONE, STATUS_LABEL, STATUS_TONE };

/** Returns "há 5 min", "há 2h", "há 3 dias", pt-BR. */
export const formatRelative = (iso) => {
  if (!iso) return "";
  const ts = new Date(iso).getTime();
  if (!ts) return "";
  const sec = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (sec < 60) return "há instantes";
  if (sec < 3600) return `há ${Math.floor(sec / 60)} min`;
  if (sec < 86400) return `há ${Math.floor(sec / 3600)}h`;
  if (sec < 86400 * 7) return `há ${Math.floor(sec / 86400)} dias`;
  return new Date(iso).toLocaleDateString("pt-BR");
};
